import React from "react";
import MasterDataListPage from "../MasterDataListPage";

export default function WarrantyPage() {
    return (
        <MasterDataListPage
            title="Master Data"
            subtitle="ประกัน"
            apiPath="/warranties" 
            fieldKey="name"
            createDefaultName="รายการใหม่" 
            initialItems={[]}
        />
    );
}
